import { directive, Swiper, SwiperSlide } from 'vue-awesome-swiper';

const SWIPER_OPTIONS = {
	slidesPerView: 1,
	pagination: {
		el: '.tab-slider-dots',
		clickable: true
	},
	observer: true,
	observeParents: true,
	loop: true
};
const TRANSITION = {
	NEXT: 'next',
	PREV: 'prev'
};

export default {
	name: 'tab-slider',
	components: { Swiper, SwiperSlide },
	directives: {
		swiper: directive
	},
	mounted() {
		this.initTabIds();
		this.setTab();
	},
	data() {
		return {
			tabIds: [],
			tabId: '',
			transitionName: ''
		};
	},
	computed: {
		swiperOptions() {
			const swiperOptions = JSON.parse(JSON.stringify(SWIPER_OPTIONS));
			swiperOptions.pagination.el += `_${this._uid}`;

			return swiperOptions;
		}
	},
	methods: {
		initTabIds() {
			if (this.$refs.tabList) {
				const listItems = this.$refs.tabList.children;
				Object.keys(listItems).forEach((key) => {
					this.tabIds.push(listItems[key].dataset.tabId);
				});
			}
		},
		setTab(id) {
			this.tabId = id ? id : this.tabIds[0];
		},
		isVisibleTab(id) {
			return this.tabId === id;
		},
		changeTab(isNext = true) {
			const tabsLength = this.tabIds.length;
			if (tabsLength > 1) {
				if (isNext) {
					this.transitionName = TRANSITION.NEXT;
					if (this.tabIds.indexOf(this.tabId) === tabsLength - 1) this.setTab(this.tabIds[0]);
					else this.setTab(this.tabIds[this.tabIds.indexOf(this.tabId) + 1]);
				} else {
					this.transitionName = TRANSITION.PREV;
					if (this.tabIds.indexOf(this.tabId) === 0) this.setTab(this.tabIds[tabsLength - 1]);
					else this.setTab(this.tabIds[this.tabIds.indexOf(this.tabId) - 1]);
					this.$nextTick(() => {
						const numberOfSlides = this.$refs[this.tabId].swiper.pagination.el.childElementCount;
						this.$refs[this.tabId].swiper.slideTo(numberOfSlides, 0);
					});
				}
			}
		},
		slidePrev() {
			this.$refs[this.tabId].swiper.slidePrev();
		},
		slideNext() {
			this.$refs[this.tabId].swiper.slideNext();
		}
	}
};
